const useEditNickname = () => {
  const validateCoin = () => {
    if (MyDataManager.getCoin() < Def.COIN_CREDIT_NICKCHANGE) {
      BLog.log('Not enough coin. Close Nick Modal.');
      return false;
    }
    return true;
  };

  const validateNickname = (newValue: string): string | null => {
    const errStrA = CommonUI.validateNick(newValue, false);
    return errStrA && errStrA.length > 0 ? errStrA[0] : null;
  };

  const checkUserStatus = (nickStatus: string) => {
    if (nickStatus === 'denied' || MembershipDataManager.getState() > 0 || MyDataManager.getPoliceVal() > 0) {
      return 'free';
    }
    if (!validateCoin()) {
      return 'notEnoughCoin';
    }
    return 'needPayment';
  };

  const updateNickname = (name: string, type: 'free' | 'paid', onSuccess: () => void, onError: (msg: string) => void) => {
    if (type === 'free') {
      MyDataManager.setNickStatus(name);
      SignalClient.mpush2('operation.nick2', { fbUid: myinfo.fbUid });

      const baObj = {
        fbUid: myinfo.fbUid,
        country: myinfo.country,
        gender: myinfo.gender,
        nick: myinfo.nick,
        newNick: name,
        status: '',
      };

      if (MyDataManager.getPoliceVal() > 0) {
        baObj.status = 'police';
      } else if (MembershipDataManager.getState() > 0) {
        baObj.status = 'membership';
      } else {
        baObj.status = 'resend';
      }
      ba('nickchange', undefined, baObj);
      onSuccess();
    } else if (type === 'paid') {
      MyDataManager.buyItem('nickname', 'change1', { nickname: name }, function (result: any, errval: any) {
        if (result) {
          SignalClient.mpush2('operation.nick2', { fbUid: myinfo.fbUid });
          const baObj = {
            fbUid: myinfo.fbUid,
            country: myinfo.country,
            gender: myinfo.gender,
            nick: myinfo.nick,
            newNick: name,
            status: 'request',
          };
          ba('nickchange', undefined, baObj);
          onSuccess();
        } else {
          const errmsg = brsc.shop_not_ready + '(E00' + errval + ')';
          onError(errmsg);
        }
      });
    }
  };

  return {
    validateNickname,
    checkUserStatus,
    updateNickname,
  };
};

export default useEditNickname;
